import './my-children.scss';
import { ChildrenList } from './children-list/children-list';
import { OnlyOneAccountAllowed } from './only-one-account-allowed/only-one-account-allowed';

export const MyChildren = () => (
    <section>
        <ChildrenList />
        <OnlyOneAccountAllowed />
    </section>
);
